module.exports = function calendlyPopup() {
    Calendly.initInlineWidget({
        url: $('#calendlyModal').data('url'),
        parentElement: $('#calendlyModal .popup-body')
    });

    function isCalendlyEvent(e) {
        return e.origin === "https://calendly.com" && e.data.event?.startsWith("calendly.");
    }

    window.addEventListener("message", function (e) {
        if (isCalendlyEvent(e)) {
            const allowedEvents = [
                "calendly.profile_page_viewed",
                "calendly.event_type_viewed",
                "calendly.date_and_time_selected",
                "calendly.event_scheduled"
            ];

            if (allowedEvents.includes(e.data.event)) {
                dataLayer.push({
                    event: e.data.event
                });
            }
        }
    });

};